<template>
  <FormInput :label-for="labelFor" :label-text="labelText"
             :show-error="showError" :error-text="errorText"
             :required="required" :smallInput="smallInput"
             class="radio" :style="isSelected"

  >
    <input @change="updateInput" v-model="model"
           :id="labelFor" type="radio" :value="value"
           :class="{ 'error': hasError }">
  </FormInput>
</template>
<script>
import FormInput from "./FormInput.vue";

export default {
  components: {FormInput},
  props: {
    labelFor: {
      type: String,
      required: true,
    },
    labelText: {
      type: String,
      required: true,
    },
    inputValue: {
      required: true,
      default: null,
    },
    modelValue: {
      required: true,
      default: null,
    },
    showError: {
      type: Boolean,
      default: false,
    },
    errorText: {
      type: String,
      default: '',
    },
    required: {
      type: Boolean,
      default: false,
    },
    smallInput: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['valueChanged'],
  data() {
    return {
      value: this.inputValue,
      model: this.modelValue,
      isCheckbox: true,
    }
  },
  watch: {
    modelValue(newValue) {
      this.model = newValue;
    }
  },
  computed: {
    hasError() {
      return this.showError && this.errorText.length > 0;
    },
    isSelected() {
      return (this.model === this.value) ? 'background-color: var(--beige); border-color: var(--brown);' : '';
    }
  },
  methods: {
    updateInput() {
      this.$emit('valueChanged', {value: this.value});
    }
  }
}
</script>
<style scoped>
.radio {
  display: flex;
  border: 1px solid #C9C9CC;
  border-radius: 8px;
  padding: 14px;
  gap: 12px;
  flex-grow: 1;
}

.radio label {
  flex-grow: 1;
}

.radio input {
  max-width: 16px;
  accent-color: var(--brown);
}

.radio input:focus {
  background-color: var(--beige);
}
</style>